import { useState } from 'preact/hooks';
import { selected, tour } from '../state/store';

const KEY = 'marrow.hint.dismissed';
const read = () => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export function FirstRunHint() {
  const [dismissed, setDismissed] = useState(read);
  if (dismissed || selected.value || tour.value) return null;
  const close = () => {
    setDismissed(true);
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* private mode: fine */
    }
  };
  return (
    <div class="first-run" data-testid="first-run-hint">
      <span>Tap anything to learn what it does. Peel layers on the left.</span>
      <button type="button" class="btn ghost icon" aria-label="Dismiss hint" onClick={close}>×</button>
    </div>
  );
}
